import styled from "styled-components";

export const StatusInfoStyled = styled.div`
  /* เลข step บนปุ่ม Edit/Action ใช้สีเดียวกับวงกลม step ด้านบน */
  .btn_step_no {
    margin-right: 4px;
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.COLORS.BLACK_1};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme, stepBgColor }) =>
      stepBgColor ? stepBgColor : theme.COLORS.YELLOW_1};
    color: ${({ theme, stepTxtColor }) =>
      stepTxtColor ? stepTxtColor : theme.COLORS.BLACK_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    line-height: 1;
  }

  .statusinfo_row_status {
    margin-bottom: 22px;
    display: flex;
    align-items: center;
    column-gap: 30px;
    .statusinfo_status {
      flex-basis: 250px;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S17};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    .statusinfo_status2 {
      flex: 1;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S17};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    /* พื้นหลังปุ่ม Edit/Action เฉพาะแถว Status */
    /* สีม่วงเฉพาะตอนมีงานให้กดปุ่มนี้ (is_action) ไม่มีงาน = สีขาวเดิม */
    &.status_main_row.is_action .theme_edit_action .btn {
      background: #d9bafa;
    }
  }

  .statusinfo_row {
    margin-bottom: 18px;
    display: flex;
    align-items: center;
    column-gap: 30px;
    .statusinfo_text1 {
      flex-basis: 250px;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
    .statusinfo_text2 {
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
    .statusinfo_text3 {
      color: ${({ theme, adminTodoColor }) =>
        adminTodoColor ? adminTodoColor : theme.COLORS.RED_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    .statusinfo_text4 {
      border-radius: 20px;
      padding: 7px 79px;
      background-color: ${({ theme, statusBgColor }) =>
        statusBgColor ? statusBgColor : theme.COLORS.YELLOW_1};
      color: ${({ theme, statusTxtColor }) =>
        statusTxtColor ? statusTxtColor : theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
    .statusinfo_link {
      text-decoration: underline;
      color: ${({ theme }) => theme.COLORS.BLUE_3};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
      cursor: pointer;
    }
    /* กรอบพื้นหลังแถว Admin To do */
    &.admin_todo_row .statusinfo_highlight {
      display: inline-block;
      border-radius: 8px;
      padding: 6px 14px;
      background-color: #d9bafa;
    }
  }
  .statusinfo_row_reserve {
    margin-bottom: 35px;
    display: flex;
    align-items: center;
    column-gap: 30px;
    .statusinfo_reserve_text1 {
      flex-basis: 250px;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
    .statusinfo_reserve_text2 {
      margin-right: 93px;
      border: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
      border-radius: 18px;
      padding: 22px 43px 18px 106px;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
    .statusinfo_reserve_date {
      .statusinfo_date {
        margin-bottom: 2px;
        color: ${({ theme }) => theme.COLORS.BLACK_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      }
      .statusinfo_date2 {
        color: ${({ theme }) => theme.COLORS.GRAY_2};
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      }
    }
  }

  .theme_standard {
  }
`;

export const PaymentsViewModalStyled = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 20px 28px;
  width: min(95vw, 960px);
  max-height: 90vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  row-gap: 18px;

  .pvm_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 16px;
  }
  .pvm_close {
    /* ขยายพื้นที่กดรอบไอคอน */
    margin: -6px;
    padding: 6px;
    display: flex;
    align-items: center;
    column-gap: 4px;
    color: ${({ theme }) => theme.COLORS.BLACK_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    cursor: pointer;
    &:hover {
      opacity: 0.6;
    }
  }

  .pvm_section_title {
    margin-bottom: 12px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S17};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
  }

  .pvm_amount_row {
    display: flex;
    align-items: baseline;
    column-gap: 30px;
    .pvm_amount_label {
      flex-basis: 170px;
      flex-shrink: 0;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S15};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    .pvm_amount_value {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
  }

  /* Booking Detail + Customer Detail (ใช้ RoomInfo/CustomerInfo ตัวเดียวกับหน้า detail) */
  .pvm_booking {
    padding-bottom: 16px;
    border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
    .pvm_detail_row {
      margin-bottom: 4px;
      display: flex;
      flex-wrap: wrap;
      column-gap: 32px;
      .pvm_detail_col {
        flex: 1;
        min-width: 300px;
      }
    }
    /* หัวข้อใน popup แคบกว่าหน้า detail ลดความกว้างคอลัมน์ label ลง */
    .room_info_row .room_info_head,
    .customer_info_row .customer_info_head {
      flex-basis: 170px;
      flex-shrink: 0;
    }
    .room_info_row,
    .customer_info_row {
      margin-bottom: 12px;
    }
  }

  .pvm_transfer {
    display: flex;
    flex-direction: column;
    row-gap: 12px;
    .pvm_section_title {
      margin-bottom: 0;
    }
  }

  .pvm_transfer_grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 24px;
    row-gap: 10px;
  }

  .pvm_title {
    color: ${({ theme }) => theme.COLORS.BLACK_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
  }

  .pvm_empty {
    color: ${({ theme }) => theme.COLORS.GRAY_2};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    text-align: center;
    padding: 24px 0;
  }

  .pvm_list {
    display: flex;
    flex-direction: column;
    row-gap: 14px;
  }

  .pvm_card {
    border: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
    border-radius: 12px;
    padding: 16px 20px;
    display: flex;
    flex-direction: column;
    row-gap: 14px;
  }

  .pvm_card_header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 16px;
    row-gap: 6px;
    padding-bottom: 10px;
    border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
    .pvm_index {
      min-width: 28px;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S15};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    .pvm_date {
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
    .pvm_method {
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
  }

  .pvm_field {
    display: flex;
    column-gap: 8px;
    align-items: baseline;
    .pvm_label {
      flex-shrink: 0;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
    .pvm_value {
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      word-break: break-word;
    }
    .pvm_link {
      color: ${({ theme }) => theme.COLORS.BLUE_3};
      text-decoration: underline;
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
  }

  .pvm_card_footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 16px;
    padding-top: 10px;
    border-top: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
    .pvm_status_wrap {
      display: flex;
      align-items: center;
      column-gap: 8px;
    }
  }
`;

export const StatusNoticeModalStyled = styled.div`
  border-radius: 12px;
  padding: 24px 28px;
  width: min(95vw, 440px);
  background: #fff;
  display: flex;
  flex-direction: column;
  row-gap: 14px;
  .snm_title {
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
  }
  .snm_message {
    color: ${({ theme }) => theme.COLORS.BLACK_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    line-height: 1.6;
  }
  .snm_action {
    display: flex;
    justify-content: flex-end;
    & > * {
      min-width: 120px;
    }
  }
`;
